export default {
  "success": true,
  "total": 0,
  "resources": {
    "leftNav": [
      {
        "id": 1,
        "iframe": false,
        "icon": "fa-th-large",
        "displayName": "Dashboard",
        "moduleId": 2,
        "actionId": 23,
        "className": "dashboard",
        "navigationURL": "/dashboard",
        "friendlyURL": "/dashboard"
      },
      {
        "childItems": [
          {
            "id": 24,
            "iframe": false,
            "displayName": "New Client",
            "moduleId": 8,
            "actionId": 6,
            "className": "new-client",
            "navigationURL": "new-client"
          },
          {
            "id": 25,
            "iframe": false,
            "displayName": "List Clients",
            "moduleId": 8,
            "actionId": 6,
            "className": "list-clients",
            "navigationURL": "/clients"
          }
        ],
        "id": 2,
        "iframe": false,
        "icon": "fa-user",
        "displayName": "Clients",
        "moduleId": 8,
        "actionId": 6,
        "className": "clients",
        "navigationURL": "",
        "friendlyURL": "/clients"
      },
      {
        "childItems": [
          {
            "id": 35,
            "iframe": false,
            "displayName": "New Quote",
            "moduleId": 31,
            "actionId": 19,
            "className": "new-quote",
            "navigationURL": "new-quote"
          },
          {
            "id": 36,
            "iframe": false,
            "displayName": "List Quotes",
            "moduleId": 31,
            "actionId": 19,
            "className": "list-quotes",
            "navigationURL": "/sales"
          },
          {
            "id": 37,
            "iframe": false,
            "displayName": "List Leads",
            "moduleId": 8,
            "actionId": 6,
            "className": "list-leads",
            "navigationURL": "/leads"
          },
          {
            "id": 38,
            "iframe": false,
            "displayName": "List Prospects",
            "moduleId": 8,
            "actionId": 6,
            "className": "list-prospects",
            "navigationURL": "/prospects"
          }
        ],
        "id": 3,
        "iframe": false,
        "icon": "fa-book",
        "displayName": "Sales",
        "moduleId": 31,
        "actionId": 19,
        "className": "sales",
        "navigationURL": "",
        "friendlyURL": "/sales"
      },
      {
        "childItems": [
          {
            "id": 43,
            "iframe": false,
            "displayName": "New Job",
            "moduleId": 2,
            "actionId": 23,
            "className": "new-job",
            "navigationURL": "new-job"
          },
          {
            "id": 44,
            "iframe": false,
            "displayName": "List Work Orders ",
            "moduleId": 2,
            "actionId": 23,
            "className": "list-work-orders",
            "navigationURL": "/dashboard"
          },
          {
            "id": 42,
            "iframe": true,
            "displayName": "Scheduled Jobs ",
            "moduleId": 46,
            "actionId": 97,
            "className": "scheduled-jobs",
            "navigationURL": "https://earth.snapsuite.io/loadmodule.aspx?moduleId=2&ActionName=&navigationId=54&showenv=true&t=d2310bab-ffe5-4c5e-85ec-06c651749e03&userid=5&u=67D12271-F4A6-458B-B276-5AFC0659CC99"
          },
          {
            "id": 45,
            "iframe": false,
            "displayName": "Scheduled Jobs New ",
            "moduleId": 46,
            "actionId": 97,
            "className": "scheduled-jobs-new",
            "navigationURL": "/scheduled/jobs"
          }
        ],
        "id": 4,
        "iframe": false,
        "icon": "fa-file-text-o",
        "displayName": "Jobs/Work Orders",
        "moduleId": 2,
        "actionId": 23,
        "className": "jobs/work-orders",
        "navigationURL": "",
        "friendlyURL": "/jobs/work orders"
      },
      {
        "childItems": [
          {
            "id": 63,
            "iframe": false,
            "displayName": "New Purchase Order",
            "moduleId": 7,
            "actionId": 24,
            "className": "new-purchase-order",
            "navigationURL": "new-po"
          },
          {
            "id": 62,
            "iframe": false,
            "displayName": "List Purchase Orders",
            "moduleId": 7,
            "actionId": 24,
            "className": "list-purchase-orders",
            "navigationURL": "/purchase-orders"
          }
        ],
        "id": 6,
        "iframe": false,
        "icon": "fa-credit-card-alt",
        "displayName": "Purchase Order",
        "moduleId": 7,
        "actionId": 24,
        "className": "purchase-order",
        "navigationURL": "",
        "friendlyURL": "/purchase order"
      },
      {
        "id": 5,
        "iframe": true,
        "icon": "fa-calendar",
        "displayName": "Calendar",
        "moduleId": 46,
        "actionId": 53,
        "className": "calendar",
        "navigationURL": "https://calendar.snapsuite.io/",
        "friendlyURL": "/calendar"
      },
      {
        "childItems": [
          {
            "id": 75,
            "iframe": false,
            "displayName": "List Invoices",
            "moduleId": 26,
            "actionId": 27,
            "className": "list-invoices",
            "navigationURL": "/invoices"
          },         
          {
            "id": 76,
            "iframe": false,
            "displayName": "List Payments ",
            "moduleId": 27,
            "actionId": 51,
            "className": "list-payments-new",
            "navigationURL": "/payments/list/v2"
          },
          {
            "id": 74,
            "iframe": true,
            "displayName": "Accounts Receivable",
            "moduleId": 26,
            "actionId": 27,
            "className": "accounts-receivable",
            "navigationURL": "https://earth.snapsuite.io/loadmodule.aspx?moduleId=3&ActionName=AccountsReceivable&navigationId=74&showenv=true&t=d2310bab-ffe5-4c5e-85ec-06c651749e03&userid=5&u=67D12271-F4A6-458B-B276-5AFC0659CC99"
          }
        ],
        "id": 7,
        "iframe": false,
        "icon": "fa-calculator",
        "displayName": "Billing",
        "moduleId": 26,
        "actionId": 27,
        "className": "billing",
        "navigationURL": "",
        "friendlyURL": "/billing"
      },
      {
        "childItems": [
          {
            "id": 80,
            "iframe": false,
            "displayName": "New Inventory",
            "moduleId": 21,
            "actionId": 39,
            "className": "new-inventory",
            "navigationURL": "new-inventory"
          },
          {
            "id": 81,
            "iframe": false,
            "displayName": "List Inventory",
            "moduleId": 21,
            "actionId": 39,
            "className": "list-inventory",
            "navigationURL": "/inventory"
          }
        ],
        "id": 8,
        "iframe": false,
        "icon": "fa-cubes",
        "displayName": "Inventory",
        "moduleId": 21,
        "actionId": 39,
        "className": "inventory",
        "navigationURL": "",
        "friendlyURL": "/inventory"
      },
      {
        "childItems": [
          {
            "id": 150,
            "iframe": false,
            "displayName": "New Pricing",
            "moduleId": 60,
            "actionId": 88,
            "className": "new-pricing",
            "navigationURL": "new-pricing"
          },
          {
            "id": 151,
            "iframe": false,
            "displayName": "List Pricing",
            "moduleId": 60,
            "actionId": 88,
            "className": "list-pricing",
            "navigationURL": "/pricing"
          }
        ],
        "id": 14,
        "iframe": false,
        "icon": "fa-money",
        "displayName": "Pricing",
        "moduleId": 60,
        "actionId": 88,
        "className": "pricing",
        "navigationURL": "/pricing",
        "friendlyURL": "/pricing"
      },
      {
        "childItems": [
          {
            "id": 90,
            "iframe": false,
            "displayName": "New Supplier",
            "moduleId": 19,
            "actionId": 56,
            "className": "new-supplier",
            "navigationURL": "new-supplier"
          },
          {
            "id": 93,
            "iframe": false,
            "displayName": "List Suppliers",
            "moduleId": 19,
            "actionId": 56,
            "className": "list-suppliers",
            "navigationURL": "/suppliers"
          }
        ],
        "id": 9,
        "iframe": false,
        "icon": "fa-truck",
        "displayName": "Suppliers",
        "moduleId": 19,
        "actionId": 56,
        "className": "suppliers",
        "navigationURL": "",
        "friendlyURL": "/suppliers"
      },
      {
        "childItems": [
          {
            "id": 100,
            "iframe": false,
            "displayName": "New Template",
            "moduleId": 17,
            "actionId": 80,
            "className": "new-template",
            "navigationURL": "new-template"
          },
          {
            "id": 103,
            "iframe": false,
            "displayName": "Email Templates",
            "moduleId": 17,
            "actionId": 80,
            "className": "email-templates",
            "navigationURL": "/templates"
          },
          {
            "id": 104,
            "iframe": false,
            "displayName": "Document Templates",
            "moduleId": 17,
            "actionId": 80,
            "className": "document-templates",
            "navigationURL": "/templates/documents"
          }
        ],
        "id": 10,
        "iframe": false,
        "icon": "fa-files-o",
        "displayName": "Templates",
        "moduleId": 17,
        "actionId": 80,
        "className": "templates",
        "navigationURL": "",
        "friendlyURL": "/templates"
      },
      {
        "childItems": [
          {
            "id": 200,
            "iframe": false,
            "displayName": "Add Employee",
            "className": "add-employee",
            "navigationURL": "add-employee"
          },
          {
            "id": 201,
            "iframe": false,
            "displayName": "List Employees",
            "className": "list-employees",
            "navigationURL": "/employees"
          }
        ],
        "id": 17,
        "iframe": false,
        "icon": "fa fa-users",
        "displayName": "Employee",
        "moduleId": 24,
        "actionId": 2,
        "className": "employee",
        "navigationURL": "",
        "friendlyURL": "/employee"
      }
    ]
  }
}